import { infoPageRegistry, type InfoPageConfig } from './registry';

type RouteRecord = {
  paths: InfoPageConfig['paths'];
  component: unknown;
  name: string;
  meta: { infoPageConfig: InfoPageConfig };
};

type LazyLoad = (importFn: () => Promise<unknown>) => unknown;

const infoPageImport = () => import('./pages/InfoPage.vue');

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);

export function generateInfoPageRoutes(lazyLoad: LazyLoad): Record<string, RouteRecord> {
  const out: Record<string, RouteRecord> = {};
  for (const cfg of infoPageRegistry) {
    out[cfg.name] = {
      paths: cfg.paths,
      component: lazyLoad(infoPageImport),
      name: cfg.name,
      meta: { infoPageConfig: cfg }
    };
    if (cfg.thematicCounsellingPath) {
      const tcName = `thematicCounselling${capitalize(cfg.name)}`;
      out[tcName] = {
        paths: { cs: `/poradna/:thematicCounselling/${cfg.thematicCounsellingPath}` },
        component: lazyLoad(infoPageImport),
        name: tcName,
        meta: { infoPageConfig: cfg }
      };
    }
  }
  return out;
}

export function getInfoPageUaRuRouteNames(): string[] {
  return infoPageRegistry.filter(cfg => cfg.availableInUaRu).map(cfg => cfg.name);
}
